import type React from "react";
import type { TenantBilling } from "../types/index.js";

interface BillingTierCardProps {
  billingList: TenantBilling[];
  onOpenPortal: (tenantId: string) => void;
}

export const BillingTierCard: React.FC<BillingTierCardProps> = ({
  billingList,
  onOpenPortal,
}) => {
  return (
    <div style={{ padding: "24px" }}>
      <div style={{ marginBottom: "16px" }}>
        <h2 style={{ margin: 0, fontSize: "16px", color: "#f8fafc" }}>
          Subscription & Billing Governance
        </h2>
        <p style={{ margin: "4px 0 0", fontSize: "13px", color: "#64748b" }}>
          Decoupled Stripe customer references. First tier is private <strong>FOUNDERS</strong>; public tiers (STARTER, GROWTH, ENTERPRISE) deferred to marketing.
        </p>
      </div>

      <div
        style={{
          padding: "12px 16px",
          marginBottom: "20px",
          backgroundColor: "#1e1e24",
          border: "1px solid #334155",
          borderRadius: "6px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
          fontSize: "12px",
          color: "#94a3b8",
        }}
      >
        <span style={{ color: "#38bdf8", fontWeight: 700 }}>PCI-DSS Invariant:</span>
        <span>
          Strictly SAQ-A / Out-of-Scope. The Instance Control Plane NEVER stores or processes cardholder numbers, CVVs, or expiration dates. All payment mutations occur inside Stripe-hosted sessions.
        </span>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
          gap: "16px",
        }}
      >
        {billingList.map((item) => {
          const isFounders = item.planTier === "FOUNDERS";
          return (
            <div
              key={item.tenantId}
              style={{
                backgroundColor: "#0f172a",
                border: `1px solid ${isFounders ? "#854d0e" : "#1e293b"}`,
                borderRadius: "8px",
                padding: "20px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "12px",
                  }}
                >
                  <span
                    style={{
                      padding: "3px 10px",
                      borderRadius: "9999px",
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                      backgroundColor: isFounders ? "#422006" : "#1e293b",
                      color: isFounders ? "#facc15" : "#38bdf8",
                      border: `1px solid ${isFounders ? "#ca8a04" : "#334155"}`,
                    }}
                  >
                    {item.planTier} {isFounders && "★ PRIVATE"}
                  </span>
                  <span
                    style={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: item.billingStatus === "active" ? "#34d399" : "#fbbf24",
                      textTransform: "uppercase",
                    }}
                  >
                    ● {item.billingStatus}
                  </span>
                </div>

                <div style={{ fontSize: "12px", color: "#94a3b8", marginBottom: "8px" }}>
                  <div>Tenant ID: <code style={{ color: "#e2e8f0" }}>{item.tenantId.slice(0, 13)}...</code></div>
                  <div style={{ marginTop: "4px" }}>
                    Stripe Customer: <code style={{ color: "#a78bfa" }}>{item.stripeCustomerId}</code>
                  </div>
                  {item.stripeSubscriptionId && (
                    <div style={{ marginTop: "4px" }}>
                      Subscription: <code style={{ color: "#64748b" }}>{item.stripeSubscriptionId}</code>
                    </div>
                  )}
                </div>
              </div>

              <div style={{ marginTop: "16px", borderTop: "1px solid #1e293b", paddingTop: "12px" }}>
                <button
                  type="button"
                  onClick={() => onOpenPortal(item.tenantId)}
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    fontSize: "12px",
                    fontWeight: 600,
                    backgroundColor: "#1e293b",
                    color: "#f8fafc",
                    border: "1px solid #334155",
                    borderRadius: "6px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "6px",
                  }}
                >
                  ↗ Launch Stripe Customer Portal (Link Only)
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
